export enum LangugesEnum {
    DE = 'deutsch',
    EN = 'english',
    IT = 'italiano'
}